<template>
  <div>
    <el-card style="margin: auto">
      <div slot="header" class="clearfix">
        <span style="float:left; font-weight: 800">{{ this.$route.params.name }} 日志</span>
      </div>
      <div>
        <p v-html="log_data" style="background-color:black;color:white;text-align:left"></p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xterm: null,
      log_data: "",
      pod: {},
      containers: [],
      container: "",
    };
  },
  created() {
    this.get_pod();
    this.get_log();
  },
  methods: {
    get_pod() {
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/pods/" +
            _this.$route.params.name +
            "?cluster=" +
            _this.$route.params.cluster +
            "&namespace=" +
            _this.$route.params.namespace,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取pod信息失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            console.log(res.data.data);
            _this.pod = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取pod信息失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
    },
    get_log() {
      console.log(this.pod);
      const _this = this;
      _this.$axios
        .get(
          _this.config.path +
            "/pods/" +
            _this.$route.params.name +
            "?cluster=" +
            _this.$route.params.cluster +
            "&namespace=" +
            _this.$route.params.namespace +
            "&log=true&line=300&container=" +
            _this.$route.query.container,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取日志失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.log_data = res.data.data.replace(/\n/g, "<br/>");
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取日志失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
  },
};
</script>
